import TableCellEditDialog from './TableCellEditDialog';

export default TableCellEditDialog;
